<template>
  <div>
    <Table
      :columns="historyColumns"
      :data="flowDetailHistory"
    ></Table>
  </div>
</template>

<script>
import { formatDate } from '@/lib/tool'
export default {
  name: 'flowHistory',
  props: {
    flowDetailHistory: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      historyColumns: [
        {
          title: '操作类型',
          key: 'ActivityShowName'
        },
        {
          title: '操作人',
          key: 'RealName',
        },
        {
          title: '执行结果',
          render: (h, params) => {
            let result = '-'
            let resultColor = ''
            switch (params.row.CompletedType) {
              case 'StartWorkflow':
                resultColor = '#19be6b'
                result = '发起'
                break
              case 'Approval':
                resultColor = '#19be6b'
                result = '通过'
                break
              case 'Reject':
                resultColor = '#ed3f14'
                result = '驳回'
                break
              case '':
                resultColor = '#ff9900'
                result = '待办'
                break
            }
            let style = {
              backgroundColor: resultColor,
              borderRadius: '50%',
              width: '6px',
              height: '6px',
              display: 'inline-block',
              marginRight: '5px'
            }
            return (
              <div>
                <div style={style}></div>
                <span>{result}</span>
              </div>
            )
          }
        },
        {
          title: '操作时间',
          render: (h, params) => {
            let time = ''
            if (params.row.CompletedTime) {
              time = parseInt(params.row.CompletedTime.slice(6, 19))
              time = formatDate(time).split(' ')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '备注',
          key: 'Opinion'
        }
      ],
    }
  }
}
</script>

